if (!customElements.get("pdp-upsell")) {
  customElements.define(
    "pdp-upsell",
    class PdpUpsell extends HTMLElement {
      constructor() {
        super();
        this.type = this.dataset.type;
        this.accordionButton = this.querySelector(`.pdp_upsell--accordion-button.button-type-${this.type}`);
        this.details = this.querySelector(`.pdp_upsell--details`);
        this.upsellCheckbox = this.querySelector(`.pdp-single-product-upsell-checkbox input[type="checkbox"]`);
        this.otherInputs = this.querySelectorAll(`.pdp-single-upsell--properties input[type="hidden"]`);
        this.pageProductFormUpsellInput = this.closest("product-info")?.querySelector("product-form input.upsells--input");
      }

      connectedCallback() {
        this.accordionButton.addEventListener("click", this.toggleAccordion.bind(this));
        if (this.upsellCheckbox) {
          this.upsellCheckbox.addEventListener("change", (e) => {
            if (e.target.checked) {
              this.otherInputs.forEach((input) => {
                input.disabled = false;
              });
            } else {
              this.otherInputs.forEach((input) => {
                input.disabled = true;
              });
            }
          });
        }
      }

      toggleAccordion(e) {
        this.details.classList.toggle("open");
        this.accordionButton.classList.toggle("open");
        this.accordionButton.querySelectorAll("span.button__text").forEach((span) => {
          span.classList.toggle("hidden");
        });
      }
    }
  );
}
